export default __webpack_public_path__ + "static/media/background_planet-02_bottom.487436a2.jpg";